import { Button, Typography } from '@mui/material';
import imgHome from '../../images/logo.png';
import './Inicio.scss';

import { useAtom } from 'jotai';
import { FC, useEffect, useRef } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { accessToken } from '../../atoms/atom';

const Inicio: FC = () => {
	const { id } = useParams<{ id: string }>();
	const [accessTokenAtom] = useAtom(accessToken);
	const isMounted = useRef(true);
	const navigate = useNavigate();

	const start = () => {
		navigate(`/${id}/pergunta`);
	}

	useEffect(() => {
		const token = accessTokenAtom || localStorage.getItem("access-token");
		if (!token && isMounted.current) {
			navigate(`/${id}/login`);
		}
	}, [accessTokenAtom]);

	return (
		<div className="inicio">
			<img
				src={imgHome}
				alt="Logo da Empresa"
				className="company-logo"
			/>
			<h1>Análise de riscos psicossociais</h1>
			<div className="basic-data">
				<h2>Dados básicos</h2>
				<Typography variant='subtitle1' align='justify'>
					Para fins de análise estatística e correlação dos riscos psicossociais,
					solicitamos algumas informações básicas sobre seu perfil. Garantimos que
					esses dados serão utilizados de forma anônima, sem qualquer identificação
					individual. O objetivo é entender melhor as características do nosso grupo
					de colaboradores e direcionar ações mais eficazes para promover a saúde e
					o bem-estar de todos.
				</Typography>
			</div>
			<Button variant='contained' color='primary' size='large' onClick={() => start()}>
				Iniciar questionário
			</Button>
		</div>
	)
}

export default Inicio;